export default __webpack_public_path__ + "static/media/salva.3d142cbe.png";